import { useEffect, useRef, useState } from 'react';
import { useLedgerStore } from '../store';

declare global {
  interface Window {
    turnstile?: {
      render: (el: HTMLElement, options: Record<string, unknown>) => string;
      reset: (widgetId?: string) => void;
      remove: (widgetId?: string) => void;
    };
  }
}

const SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || '1x00000000000000000000AA';

export function resetTurnstile(): void {
  try {
    window.turnstile?.reset();
  } catch {
    // No-op: local dev without the widget still works after setting dummy keys.
  }
}

export function TurnstileGate() {
  const ref = useRef<HTMLDivElement | null>(null);
  const widgetRef = useRef<string | null>(null);
  const setHumanToken = useLedgerStore((store) => store.setHumanToken);
  const token = useLedgerStore((store) => store.humanToken);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const timer = window.setInterval(() => {
      if (cancelled || !ref.current || !window.turnstile || widgetRef.current) return;
      widgetRef.current = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY,
        theme: 'dark',
        callback: (value: string) => setHumanToken(value),
        'expired-callback': () => setHumanToken(''),
        'error-callback': () => setHumanToken('')
      });
      setLoaded(true);
      window.clearInterval(timer);
    }, 250);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
      if (widgetRef.current && window.turnstile) window.turnstile.remove(widgetRef.current);
      widgetRef.current = null;
    };
  }, [setHumanToken]);

  return (
    <div>
      <div className="turnstile-wrap" ref={ref} aria-label="Cloudflare Turnstile human check">
        {!loaded ? <span className="micro">Loading human check…</span> : null}
      </div>
      <p className="micro">
        {token ? 'Human pass ready for the next write.' : 'Complete the human pass before saving a trust decision.'}
      </p>
    </div>
  );
}
